import { PassingLineProps } from '../../types';

/**
 * Renders the pass/fail threshold marker tick around the score circle based on
 * the provided passing threshold and values. The component calculates the
 * appropriate index for the passing threshold and renders a single tick at
 * that position.
 */
export const PassingLine: React.FC<PassingLineProps> = ({
  passingThreshold = 0,
  values,
  style,
}) => {
  /** Calculate the index of the passing threshold within the values array. */
  const maxIndex = Math.max(0, values.length - 1);

  /** Determine the index corresponding to the passing threshold. */
  const thresholdIndex = Math.max(
    0,
    Math.min(maxIndex, Math.round((passingThreshold / 100) * maxIndex)),
  );

  // Render a single passing line at the calculated threshold index,
  // while keeping all other positions empty.
  return values.map((value, index: number) => {
    // Only render the passing line at the calculated threshold index,
    // keeping all other positions empty.
    if (index !== thresholdIndex) return null;

    // The container div is rotated to position the passing line correctly
    // around the circle, while the inner div applies the visual
    // styling of the tick.
    const containerStyle: React.CSSProperties = {
      pointerEvents: 'none',
      position: 'absolute',
      height: '100%',
      transform: `rotate(${value}turn)`,
    };

    // Render the passing line at the calculated threshold index.
    return (
      <div key={value} style={containerStyle}>
        <div style={style} />
      </div>
    );
  });
};

PassingLine.displayName = 'PassingLine';

export default PassingLine;
